import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  *, 
  *::after, 
  *::before {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    list-style:none;
  }
  
  body {
    font-family: "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
    "Droid Sans", "Helvetica Neue", sans-serif;
    height: 100vh;
    text-rendering: optimizeLegibility;
  }
 
  .grayscaleMap {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
  }
`;
